import moment from 'moment-timezone';
import Constants from '../constants/constants';
var regex = Constants.Regex;
/**
 * * checks if a tcm is valid for the given user type (dispatcher or field user)
 * @param _tcm
 * @param userType
 * @returns {*}
 */
function checkTCMValidity(_tcm, userType) {
	var _isDirty = false;//assume false unless we find a change
	var errors = [];
	var warnings = [];
	var dateRegex = new RegExp(regex.dateRegex);

	if (!_tcm.estimatedRemovalDate || _tcm.estimatedRemovalDate.length === 0) {
		errors.push({
			field: 'estimatedRemovalDate',
			message: 'Estimated Removal: Please fill out this field',
			type: 'error'
		})
	} else if (!dateRegex.test(_tcm.estimatedRemovalDate)) {
		_isDirty = true;
		errors.push({ field: 'estimatedRemovalDate', message: 'Estimated Date: must be in format MMddYY', type: 'error' });
	}

	if (!_tcm.authorizedBy || _tcm.authorizedBy.length === 0) {
		errors.push({
			field: 'authorizedBy', message: 'Authorized By: Please fill out this field', type: '' +
				'.error'
		})
	}

	if (_tcm.workStartMp.length === 0 && _tcm.workStartMpSuffix.length === 0 && _tcm.workEndMp.length === 0 && _tcm.workEndMpSuffix.length === 0) {
		if (!_tcm.fromLocation || _tcm.fromLocation.length === 0) {
			errors.push({
				field: 'fromLocation', message: 'From Location: Either From Location or MP is mandatory', type: '' +
					'.error'
			})
		}

		if (!_tcm.toLocation || _tcm.toLocation.length === 0) {
			errors.push({
				field: 'toLocation', message: 'To Location: Either To Location or MP is mandatory', type: '' +
					'.error'
			})
		}
	}

	//Estimates Removal validation
	let now = moment().tz(Constants.Timezones[_tcm.timezone]);
	let estimatedRemoval = moment.tz(_tcm.estimatedRemovalDate, 'MMDDYY', Constants.Timezones[_tcm.timezone]);

	//verify that estivatedRemoval is a valid date
	if (estimatedRemoval.isValid()) {

		estimatedRemoval.add(23, 'hours').add(59, 'minutes').add(59, 'seconds'); //Set the estimatedRemoval to the end of the day so that it will not be in the past

		if (estimatedRemoval.isBefore(now)) {
			errors.push({
				field: 'expectedExpireDate',
				message: "Estimated Removal Date can't be in the past",
				type: 'error'
			})
		}
	}
	else {
		errors.push({
			field: 'expectedExpireDate',
			message: "Estimated Removal Date must be a valid date",
			type: 'error'
		})
	}

	//This is to filter out only spaces
	let onlySpacesComment = _tcm.comments.map(function (comment) {
		return comment['comment']
	})

	if (_tcm.comments.length === 0 || _tcm.comments[0].comment === "" || onlySpacesComment.join("").trim().length === 0) {
		errors.push({
			field: 'TCMText', message: 'Text: Please fill out this field', type: '' +
				'.error'
		})
	}

	return { isValid: errors.length === 0, errors: errors, isDirty: _isDirty, warnings: warnings }

}
export const tcmValidation = { checkTCMValidity };